module.exports = __webpack_public_path__ + "img/lb3.3c17c4b8.png";